<div [fxLayout]="'row wrap'"
  class="dropdown-search"
  [ngClass]="{'dropdown-search__error': displayErrorText && errorText && !isMobile,
              'dropdown-search__root-mobile': isMobile}"
  fxLayoutAlign="start start">
  @if (qrScanCategory && (qrScanEnabled$ | async)) {
    <button
      class="dropdown-search__qr-button"
      [ngClass]="{'dropdown-search__qr-button-mobile': isMobile}"
      data-testid="dropdown-search-qr-scan"
      mat-stroked-button
      type="button"
      title="Scan Customer QR Code"
      (click)="openQrScanner()">
      <mat-icon>qr_code_scanner</mat-icon>
    </button>
  }
  @if (categories && displayAdvancedSearchBox) {
    <div
      [ngClass]="{'dropdown-search__mobile': isMobile}"
      id="dropdown">
      <button type="button" class="dropdown-search__base-container"
         [ngClass]="{'dropdown-search__base-container-desktop': !isMobile,
                     'dropdown-search__base-container-mobile': isMobile,
                     'dropdown-search__mobile-error-base': displayErrorText && errorText && isMobile}"
        [attr.aria-expanded]="dropdownOpen"
        (click)="toggleDropdown()">
        <span class="dropdown-search__base-header-text"
           [ngClass]="{'dropdown-search__base-header-text-desktop': !isMobile,
                       'dropdown-search__base-header-text-mobile': isMobile}">
          {{headerText}}
        </span>
        @if (!isMobile) {
          <span class="dropdown-search__selected">
            {{this.selectedCategory}}
          </span>
        }
        <span class="dropdown-search__chevron-closed"
          [ngClass]="{'dropdown-search__chevron-closed-mobile': isMobile}">
          <img alt="" class="dropdown-search__expand-more-icon" src="https://www.cfacdn.com/img/Spotlight/Icons/DropdownArrow.png"/>
        </span>
      </button>
      @if (dropdownOpen && !isMobile) {
        <div
          class="dropdown-search__expanded-container"
          id="expanded-dropdown"
         [ngClass]="{'dropdown-search__expanded-container-desktop': !isMobile,
                     'dropdown-search__expanded-container-mobile': isMobile}">
          <div fxLayout="row" fxLayoutAlign="start center">
            <div class="dropdown-search__expanded-header-text" data-testid="dropdown-search-header">{{headerText}}</div>
            <button type="button"
              class="dropdown-search__chevron-button"
              aria-label="Close categories"
              (click)="toggleDropdown()">
              <mat-icon matSuffix>
                <img alt="" class="dropdown-search__chevron-icon" src="https://www.cfacdn.com/img/Spotlight/Icons/DropdownArrow.png"/>
              </mat-icon>
            </button>
          </div>
          @for (category of categories; track category.title; let i = $index; let isLast = $last) {
            <div
              class="dropdown-search__row-hover"
              [ngClass]="{'dropdown-search__selected-category': category.title === selectedCategory}">
              <button type="button" class="dropdown-search__categories" [attr.data-testid]="'dropdown-search-title-' + i" (click)="selectCategory(category)">{{category.title}}</button>
              @if (!isLast) {
                <hr>
                }
              </div>
            }
          </div>
        }
        @if (dropdownOpen && isMobile) {
          <button type="button"
            class="dropdown-search__mobile-slide-up"
            aria-label="Open search categories"
            (click)="openMobileCategories()">
          </button>
        }
      </div>
    }

    <div class="dropdown-search__search"

      [hidden]="selectedCategoryObject && selectedCategoryObject.isAutocomplete"
       [ngClass]="{'dropdown-search__search-desktop': !isMobile,
                   'dropdown-search__search-mobile': isMobile,
                   'dropdown-search__search-without-advanced-search': !displayAdvancedSearchBox,
                   'dropdown-search__mobile-error-search': displayErrorText && errorText && isMobile}"
      data-testid="dropdown-search">
      <mat-icon matPrefix class="dropdown-search__search-icon">search</mat-icon>
      <input #searchInput matInput
        class="dropdown-search__search-placeholder-text"
        [maxlength]="getMaxLength()"
        [ngModel]="searchTerm"
        [placeholder]="getPlaceholderText()"
        data-testid="dropdown-search-input"
        (keyup)="search(searchInput.value, $event)">
      @if (searchTerm || displayErrorText) {
        <button type="button"
          class="dropdown-search__search-close"
          aria-label="Clear search"
          (click)="clearSearch.emit(clearSearchTerm())">
          <mat-icon matSuffix>close</mat-icon>
        </button>
      }
    </div>
    @if (selectedCategoryObject && selectedCategoryObject.isAutocomplete) {
      <spot-autocomplete
        [ngClass]="{'dropdown-search__mobile-margin': isMobile}"
        [items]="(autocompleteCustomers$ | async)"
        [loading]="(autocompleteCustomersLoading$ | async)"
        [placeholder]="getPlaceholderText()"
        [noResultsText]="noResultsText"
        [isBorderStyling]="true"
        [shouldMaintainSelectionText]="true"
        [autoCompleteSearchTerm]="autoCompleteSearchTerm"
        [isWithDropdown]="true"
        [isMobile]="isMobile"
        (valueChange)="valueChange.emit($event)"
        (selectionMade)="selectionMade.emit($event)"
        (clearSearchCriteria)="clearAutocompleteSearchTerm.emit()">
      </spot-autocomplete>
    }
  </div>
  @if (displayErrorText && errorText) {
    <div
      class="dropdown-search__error-text"
     [ngClass]="{'dropdown-search__error-text-desktop': !isMobile,
                 'dropdown-search__error-text-mobile': isMobile}">
      <div [fxLayout]="'row wrap'">
        <mat-icon class="dropdown-search__error-text-icon">warning_amber</mat-icon>
        <div class="dropdown-search__error-text-message">{{errorText}}</div>
      </div>
    </div>
  }

  <div class="dropdown-search__example-text"
     [ngClass]="{'dropdown-search__example-text-desktop': !isMobile,
                 'dropdown-search__example-text-mobile': isMobile}">
    @if (exampleText) {
      <div>
        {{exampleText}}
      </div>
    }
    @if (exampleTextNote) {
      <div class="dropdown-search__example-text-note">
        {{exampleTextNote}}
      </div>
    }
  </div>
